<template>
  <div class="solution_layer">
    <div class="background"></div>
    <div class="background"></div>
    <div class="background"></div>
    <div class="background last"></div>
    <div class="page_1 align_center">
      <div class="contents_wrapper">
        <div class="limited_width_box">
          <div class="title main">
            <span class="text nowrap dark_sky__">JinSolutions</span>
            <span class="text nowrap">Web-Based</span>
            <span class="text nowrap">Integrated</span>
            <span class="text nowrap">Management</span>
            <span class="text nowrap">System</span>
          </div>
          <div class="description main one effect_line">
            <span class="text">
              JinSolutions is <span class="dark_sky__">The Project Progress Management System</span> for 
              Oil & Gas Industry. Throughout the life-cycle management, it can support you to easily monitor
              and manage the entire process of the project-related fields through its powerful tools such as
              the <span class="dark_sky__">Web-Based 3D Progress Viewer</span>.
            </span>
            <span class="line"></span>
          </div>
          <div class="section_wrapper">
            <v-btn depressed @click="goto">
              GO TO JINSOLUTIONS
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { ScrollMixin } from '@/mixins/scroll.mixin'

export default {
  name: 'solution',
  mixins: [
    ScrollMixin
  ],
  computed: {
    ...mapState(['scale']),
  },
  mounted() {
    this.init()
    this.$emit('mounted', 'solution')
  },
  methods: {
    init() {
      let ts = document.querySelectorAll('.solution_layer .title.main span')
      ts.forEach(t => {
        t.innerHTML = t.textContent.replace(/\S/g, "<span class='letter' style='display: inline-block;'>$&</span>")
      })

      this.setScrollAnime([
        { 
          targets: [
            { name: '.solution_layer .page_1 .title.main', items: '.solution_layer .page_1 .title.main span', status: 'opened' },
          ], 
          in: {
            translateX: [40, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 750,
            delay: (el, i) => 15 * i
          },
          out: {
            translateX: [0, -40],
            translateZ: 0,
            opacity: [1, 0],
            easing: "easeOutExpo",
            duration: 750,
            delay: (el, i) => 15 * i
          }
        },
        { 
          targets: [
            { name: '.solution_layer .page_1 .description.one', status: 'opened' },
            { name: '.solution_layer .page_1 .section_wrapper', status: 'closed' },
          ], 
          in: {
            translateX: [100, 0],
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 2500
          },
          out: {
            translateX: -300,
            opacity: 0,
            easing: "easeOutExpo",
            duration: 2500
          }
        },
      ])
    },
    open() {
      let w = window.outerWidth
      let dgs = document.querySelectorAll('.solution_layer .background').length
      let dgWidth = 5

      this.$anime.timeline({loop: false})
      .add({
        targets: '.solution_layer .background',
        left: (el, i) => [w, i * dgWidth],
        duration: 1000,
        delay: (el, i) => 75 * i
      })
      .add({
        targets: '.solution_layer .background.last',
        width: [dgWidth, w - (dgs-1) * dgWidth],
        easing: "easeOutExpo",
        duration: 500,
      })
      .add({
        targets: '.solution_layer .background',
        opacity: 0,
        easing: "easeOutExpo",
        duration: 10000
      })

      this.$anime({
        targets: '.solution_layer .page_1 .title.main span',
        translateX: [40, 0],
        translateZ: 0,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1500,
        delay: (el, i) => 1250 + 30 * i
      })

      let elbox = document.querySelector('.solution_layer .page_1 .description.one').getBoundingClientRect()
      // set scaled width
      w = parseInt(elbox.width / this.scale)
      this.$anime.timeline({loop: false})
      .add({
        targets: '.solution_layer .page_1 .description.effect_line .line',
        scaleY: [0, 1],
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 500,
        delay: 1500
      })
      .add({
        targets: '.solution_layer .page_1 .description.effect_line .line',
        translateX: [0, w],
        easing: "easeOutExpo",
        duration: 750,
        delay: 100
      })

      this.$anime({
        targets: '.solution_layer .page_1 .description.effect_line .text',
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1500,
        delay: 2350
      })

      this.openOverContents(2500, 150)
    },
    close() {
      window.scrollTo(0, 0)
      
      this.$anime({
        translateY: [0, -100],
        targets: '.solution_layer',
        opacity: 0,
        easing: "easeOutExpo",
        duration: 500
      })
      setTimeout(() => {
        this.$emit('closed', 'solution')
      }, 500)
    },
    goto() {
      window.open('https://www.jinsolutions.com', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.solution_layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;

  .background {
    position: fixed;
    top: 0;
    right: -35px;
    bottom: 0;

    width: 5px;
    background: rgba(0, 0, 0, .1);
  }

  .image_wrapper {
    padding: 3rem;
    border: .5rem solid rgba(0, 0, 0, .1);
    border-radius: 1rem;
    -moz-border-radius: 1rem;
    -webkit-border-radius: 1rem;

    background-color: rgba(255, 255, 255, .1);
    
  }

  .v-btn {
    min-height: 7rem;
    padding: 0 5rem 0 5rem !important;
    margin-top: 3rem;
  }
}
</style>